<template>
  <el-tooltip
    effect="dark"
    content="余额不足用户"
    placement="bottom">
    <el-popover
      placement="bottom-end"
      width="700"
      :value="active"
      trigger="click">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>余额不足房间</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="alarmRoomExport()">导出</el-button>
        </div>
        <el-table
          :data="orderList.filter(data => !search || data.roomCode.toLowerCase().includes(search.toLowerCase()) )"
          max-height="400">
          <el-table-column property="name" >
            <template slot="header" slot-scope="scope">
              <el-input
                v-model="search"
                size="mini"
                placeholder="房间编号"/>
            </template>
            <template slot-scope="scope">
              <el-tag>{{ scope.row.roomCode }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="用户名称">
            <template slot-scope="scope">
              <el-tag>{{ scope.row.roomName }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="报警值">
            <template slot-scope="scope">
              <el-tag>{{ scope.row.alarmEnergy }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="账户余额"
                           align="right">
            <template slot-scope="scope">
              <el-tag style="width: 100px" :type="scope.row.balanceFee > 0 ? 'success':'danger'"
                      :effect="scope.row.balanceFee > 0 ? 'plain':''"
              >
                {{parseFloat(scope.row.balanceFee).toFixed(3)}}
              </el-tag>
              <el-tag
                :type="scope.row.balanceFee > 0 ? 'success':'danger'"
                :effect="scope.row.balanceFee > 0 ? '':'dark'">
                ¥
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <!--      <el-button slot="reference">click 激活</el-button>-->
      <el-button
        class="d2-ml-0 d2-mr btn-text can-hover"
        type="text"
        slot="reference">
        <el-badge :value="orderList.length" class="item">
          <d2-icon
            name="bell"
            style="font-size: 20px"/>
        </el-badge>
      </el-button>
    </el-popover>
  </el-tooltip>
</template>

<script>
import {updateRechargeOrderById} from '@/api/rechargeOrder'
import qs from 'qs'
import {findInsufficientBalanceVoPage} from '@/api/statistical_report/room_billing_statement'
import {mapActions, mapState} from 'vuex'

export default {
  data () {
    return {
      filename: __filename,
      search: '',
      timerId: null,
      orderList: [],
      showOrHide: false,
      loading: false
    }
  },
  computed: {
    ...mapState('d2admin/logShow', [
      'active'
    ])
    // tooltipContent () {
    //   return this.orderList.length === 0
    //     ? '没有申请绑定用户'
    //     : `${this.orderList.length} 条日志${this.logLengthError > 0
    //       ? ` | 包含 ${this.logLengthError} 个异常`
    //       : ''}`
    // }
  },
  mounted () {
    let _this = this
    _this.findInsufficientBalanceVoPage()
    this.timerId = setInterval(_this.findInsufficientBalanceVoPage, 1800000)
  },
  methods: {
    ...mapActions('d2admin/logShow', [
      'toggle'
    ]),
    findInsufficientBalanceVoPage () {
      findInsufficientBalanceVoPage().then(res => {
        this.orderList = res.data
      }).catch(err => {
        this.$notify({
          title: '数据请求异常'
        })
        console.log('err', err)
      })
    },
    closeTimer () {
      clearInterval(this.timerId)
      this.timerId = null
    },
    updateRechargeOrderById (index, row, rows) {
      let obj = {}
      obj.orderId = row.orderId
      obj.orderStatus = 0
      updateRechargeOrderById(qs.stringify(obj)).then(res => {
        rows.splice(index, 1)
      }).catch(err => {
        console.log(err)
      })
    },
    alarmRoomExport () {
      const columns = [
        { label: '房间编号', prop: 'roomCode' },
        { label: '用户名称', prop: 'roomName' },
        { label: '房间余额', prop: 'balanceFee' }
      ]
      const data = JSON.parse(JSON.stringify(this.orderList))
      this.$export.excel({
        columns,
        data,
        title: '报警房间',
        header: `报警房间`,
        merges: ['A1', 'C1']
      })
        .then(() => {
          // ...可选回调
        })
    }
  },
  beforeDestroy () {
    if (this.timerId) {
      console.log("clearInterval")
      clearInterval(this.timerId)
      this.timerId = null
    }
  }
}
</script>
<style>
.text {
  font-size: 14px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-log/index.vue"
}
</vue-filename-injector>
